import Basketball from './Components/Basketball/Basketball'
import NavBar from './Components/Basketball/NavBar/NavBar';
import Ace from './Components/Ace';
import Doodles from './Components/Doodles';
import Wildwest from './Components/Wildwest';
import Mavericks from './Components/Mavericks';
import Kpako from './Components/Kpako';
import Underdogs from './Components/Underdogs';
import Ringerz from './Components/Ringerz';
import Standings from './Components/Standings';
import Female from './Components/Female';
import GlobalStyle from './GlobalStyle'
import Teams from './Components/Teams'
import Schedule from './Components/Schedule'
import Stats from './Components/Stats'
import Draft from './Components/draft'
import './Base'

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'


function App () {
  return(
    <>
      <Router>
        <GlobalStyle/>
        <NavBar/>
        <Routes>
          <Route path='/' element={<Basketball/>}/>
          <Route path="/ace" element={<Ace/>}/>
          <Route path="/doodles" element={<Doodles/>}/>
          <Route path="/wildwest" element={<Wildwest/>}/>
          <Route path="/underdogs" element={<Underdogs/>}/>
          <Route path="/ringerz" element={<Ringerz/>}/>
          <Route path="/mavericks" element={<Mavericks/>}/>
          <Route path="/kpako" element={<Kpako/>}/>
          <Route path="/standings" element={<Standings/>}/>
          <Route path='/female' element={<Female/>}/>
          <Route path='/teams' element={<Teams/>}/>
          <Route path='/schedule' element={<Schedule/>}/>
          <Route path='/stats' element={<Stats/>}/>
          <Route path='/draft' element={<Draft/>}/>
        </Routes>
      </Router>
    
    </>
  )
}
export default App


